// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] + "." + {"43":"a0976eff","234":"e796cbd3","653":"d7ab68ea","844":"d6387ad2"}[chunkId] + ".chunk.css";
};